// Club member role display. One source for the Members tabs (Manage + club page).
export const ROLE_LABEL = { admin: "Admin", "e-board": "E-Board", member: "Member" };
export const ROLE_CLASS = { admin: "r-admin", "e-board": "r-eboard", member: "r-member" };

/**
 * Normalise a stored member_role to a ROLE_LABEL / ROLE_CLASS key, the same way
 * components/ui/RoleBadge.js does: admin -> admin, member or empty -> member,
 * anything else (prod also has "e_board" / "eboard") -> e-board.
 */
export function roleKey(role) {
  const k = String(role || "member").toLowerCase();
  return k === "admin" || k === "member" ? k : "e-board";
}
